import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Consulting">
                <h1>Digital Transformation Consulting Services</h1>
              </div>
              <p className="main_para">
                Embrace the digital change for a bright future by improving
                efficiency and productivity, reducing costs, enhancing customer
                experiences, and increasing revenue.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_content_txt">
              <p>
                As premier digital transformation consultants, our digital
                transformation services provide our clients to build
                world-changing ideas by leveraging emerging technologies,
                methodologies, and techniques.
              </p>
              <ul>
                <li>Digital Strategy</li>
                <li>Cloud Assistance</li>
                <li>Architecture Design</li>
                <li>Process Development</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
